import { EARTH_METERS_PER_DEG_LAT } from './markerSpider.constants';

export function offsetLatLngByMetersNorthEast(
  latitude: number,
  longitude: number,
  northMeters: number,
  eastMeters: number
): { latitude: number; longitude: number } {
  const cosLatitude = Math.cos((latitude * Math.PI) / 180);
  const metersPerDegreeLongitude =
    EARTH_METERS_PER_DEG_LAT * (cosLatitude || 1e-6);
  return {
    latitude: latitude + northMeters / EARTH_METERS_PER_DEG_LAT,
    longitude: longitude + eastMeters / metersPerDegreeLongitude,
  };
}
